import styled from 'styled-components';
import { Slider } from '@/ui';
import { COLORS } from '@/theme';

export const StyledSlider = styled(Slider)`
  width: 100%;
  .ant-slider-tooltip {
    transform: translateX(-50%) !important;
    white-space: nowrap;
  }

  .ant-slider-tooltip-inner {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ant-slider-rail {
    background: ${COLORS.WHITE_SMOKE};
  }
  .ant-slider-track {
    background: ${COLORS.ORANGE_PRIMARY};
  }
  .ant-slider-handle::after {
    background: ${COLORS.SILVER};
    box-shadow: none;
  }
`;
